import { useState, useEffect } from 'react';
import { getAnimationClass } from './../utils';

import ClassifiedMultiStepImage from './images/classified-multistep.png';

export default function ClassifiedMultiStep({ onComplete }) {
  const [showText, setShowText] = useState(false);
  const [showImage, setShowImage] = useState(false);

  useEffect(() => {
    const timeouts = [];
    let currentTime = 500;

    timeouts.push(setTimeout(() => setShowText(true), currentTime));

    currentTime += 4000;
    timeouts.push(setTimeout(() => setShowImage(true), currentTime));

    // Hold on the final layout long enough for the player to read the
    // copy and take in the image (~9 seconds total).
    currentTime += 4500;
    timeouts.push(setTimeout(() => onComplete?.(), currentTime));

    return () => timeouts.forEach(clearTimeout);
  }, [onComplete]);

  return (
    <>
      <h1 className="animate-fade-in">Classified &amp; Multi-Step Financial Statements</h1>

      <p className={getAnimationClass(showText)}>
        Major companies often report their financial statements using the <b>Classified Balance Sheet</b> and <b>Multi-Step Income Statement</b> formats. In this level, you&rsquo;ll practice building both by sorting each account to their correct section.
      </p>

      <img
        src={ClassifiedMultiStepImage}
        alt="Classified & Multi-Step Financial Statements"
        className={`transition-image big-margin ${getAnimationClass(showImage)}`}
      />
    </>
  );
}
